import { createAsyncThunk } from "@reduxjs/toolkit"
import { asyncThunkWrapper } from "../thunkHandler"
import { BASEURI, headers } from "../../utils/helper"

// --------------- Retrieve docs ---------------
export const handleRetrieveDocs = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/member/specialists/${data?.id}/documents`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)